import { FacetLoadingStateService } from '@common/facet/facet-loading-state.service';
import { MatingService } from '../../../matings/mating.service';
import { VocabularyService } from '../../../vocabularies/vocabulary.service';
import {
    Component,
    Input,
    OnInit,
    OnChanges
} from '@angular/core';
import { LocationService } from '../../../locations/location.service';


@Component({
    selector: 'workflow-mating-details',
    templateUrl: './workflow-mating-details.component.html',
})
export class WorkflowMatingDetailsComponent implements OnInit, OnChanges {
    @Input() mating: any;
    @Input() useTableFormat: boolean;

    constructor(
        private facetLoadingStateService: FacetLoadingStateService,
        private locationService: LocationService,
        private matingService: MatingService,
        private vocabularyService: VocabularyService
    ) { }

    ngOnInit() {
        this.initialize();
    }

    ngOnChanges(changes: any) {
        if (changes.mating && !changes.mating.firstChange) {
            this.getMatingDetails();
        }
    }
    
    initialize(): Promise<any> {
        this.facetLoadingStateService.changeLoadingState(true);
        return this.getMatingDetails().then(() => {
            return this.getCVs();
        }).then(() => {
            this.facetLoadingStateService.changeLoadingState(false);
        }).catch((error: Error) => {
            this.facetLoadingStateService.changeLoadingState(false);
            throw error;
        });
    }

    getCVs(): Promise<any> {
        // // Ensure CVs loaded for mating
        const p1 = this.vocabularyService.ensureCVLoaded('cv_MatingStatuses');
        const p2 = this.vocabularyService.ensureCVLoaded('cv_MatingTypes');

        return Promise.all([p1, p2]);
    }

    getMatingDetails(): Promise<any> {
        if (!this.mating) {
            return Promise.resolve();
        }
        const expands = [
            'Line'
        ];
        return this.matingService.getMating(this.mating.C_MaterialPool_key, expands).then(() => {
            return this.locationService.getMaterialPoolLocationPath(
                this.mating.C_MaterialPool_key
            );
        }).then((path) => {
            this.mating.location = path;
        });
    }
}
